import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import baoCaoTuTapReducer from './slices/baoCaoTuTap';
import baoCaoTuHocReducer from './slices/baoCaoTuHoc';
import bqlSystemManageReducer from './slices/bqlSystemManage';
import dangKyLuuTruReducer from './slices/dangKyLuuTru';
import capNhatThongTinReducer from './slices/capNhatThongTin';
import dangKyThucTapReducer from './slices/dangKyThucTap';
import thongBaoTrangChuReducer from './slices/thongBaoTrangChu';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    systemManage: bqlSystemManageReducer,
    customization: customizationReducer,
    result: baoCaoTuTapReducer,
    baoCaoTuHoc: baoCaoTuHocReducer,
    dangKyLuuTru: dangKyLuuTruReducer,
    capNhatThongTin: capNhatThongTinReducer,
    dangKyThucTap: dangKyThucTapReducer,
    thongBaoTrangChu: thongBaoTrangChuReducer
});

export default reducer;
